<template>
  <el-form style="margin: 0 10px" ref="form" :model="form" label-position="top">
    <el-form-item label="模板Id">
      {{ theme.userName }}.{{ theme.name }}
    </el-form-item>
    <el-form-item label="标签">
      <el-select
        v-model="form.tags"
        style="width: 100%;"
        size="small"
        multiple
        filterable
        allow-create
        default-first-option
        placeholder="请选择内容标签">
        <el-option
          v-for="tagName in form.tags"
          :key="tagName"
          :label="tagName"
          :value="tagName">
        </el-option>
      </el-select>
    </el-form-item>
  </el-form>

  <el-divider></el-divider>

  <div class="el-dialog__footer">
    <el-button type="primary" @click="btnSubmitClick">确 定</el-button>
    <el-button @click="btnCancelClick">取 消</el-button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IElForm } from '@/types/element';
import { ITheme } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/themes';

export default defineComponent({
  emits: ['cancel', 'submit'],
  props: {
    theme: {
      type: Object as PropType<ITheme>,
      required: true,
    },
  },
  data() {
    return {
      form: { ...this.theme },
    };
  },
  methods: {
    apiSubmit() {
      api.setTags(this.form, (res) => {
        if (!res) return;

        utils.success('模板标签设置成功！');
        this.$emit('submit', this.form);
      });
    },

    btnCancelClick() {
      this.$emit('cancel');
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.apiSubmit();
        }
      });
    },
  },
  watch: {
    theme(value) {
      this.form = { ...value };
    },
  },
});
</script>
